import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import CombineOrders from '../../../components/tabs/OrderDetailsModal/CombineOrders'

import { combineOrders } from '../../../actions/orders/combine'

import { makeGetTabOrder, makeGetCombinableSuiteOrders } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder } from '../../../selectors/suites'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'
import { TabOrderRowsViewModel } from '../../../viewmodels/TabOrdersViewModel'

const mapStateToProps = (state, ownProps) => {
  // destination order
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)

  // orders that can be combined with the destination order
  const getCombinableSuiteOrders = makeGetCombinableSuiteOrders()
  const userNotes = order?.userNotes ?? ''
  const customerId = order?.customerId ?? ''
  const revenueCenterId = order?.revenueCenterUuid ?? ''
  const combinableOrders = TabOrderRowsViewModel(getCombinableSuiteOrders(state, customerId, revenueCenterId, orderId))

  return {
    ...order,
    combinableOrders,
    suiteInformation,
    userNotes,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const replace = ownProps?.history?.replace ?? function(){}

  return {
    onClose: () => replace(`/tabs/${orderId}/more`),
    onCombineOrders: (orderIdToCombine) => {
      dispatch(combineOrders({ combinedOrderUuid: orderIdToCombine, destinationOrderUuid: orderId }))
      replace(`/tabs/${orderId}`)
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CombineOrders))
